import { Content, FormSection, FormTitle, Input, Wrapper } from "./styles";
import {
  Button,
  StyledButton,
  TextPlain,
  TitleH2
} from "../../../../components/generic";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../components/Modal";
import { DialogWrapper } from "../../../../components/containers";
import { SmallLoader } from "../../../../components/SmallLoader";
import { UserAPI } from "../../../../API/userApi";
import { IEmail } from "interfaces/intarfaces";

export const PreferToBeCalledSection = () => {
  const { t, i18n } = useTranslation("home");

  const [showModal, setShowModal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [required, setRequired] = useState(false);

  const [formState, setFormState] = useState({
    firstName: "",
    email: "",
    phone: ""
  });
  const [errors, setErrors] = useState({
    firstName: "",
    email: "",
    phone: "",
    form: ""
  });

  function isValidEmail(email: string) {
    return /\S+@\S+\.\S+/.test(email);
  }

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      email:
        !isValidEmail(formState.email) && formState.email
          ? t("formSection.errors.invalidEmail")
          : ""
    }));
  }, [formState]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: false, form: "" }));
  };
  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrors((prev) => ({
      ...prev,
      [e.target.name]:
        !formState[e.target.name as keyof typeof formState].trim()
    }));
  };

  const sendData = () => {
    setLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "contact_me",
        first_name: formState.firstName.trim() as string,
        phone: formState.phone.trim() as string,
        browser_language: i18n.language

      } as IEmail)
    };

    fetch(
      process.env.REACT_APP_AWS_ENDPOINT! +
      `contact-us/${formState.email.trim() as string}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setShowModal(1);
        setFormState({ phone: "", email: "", firstName: "" });
        setLoading(false);
      })
    .finally(() => {
      setLoading(false);
    });
    };

  const submit = () => {
    const { phone, email, firstName } = formState;
    setErrors({
      email: !(isValidEmail(formState.email) && formState.email.trim())
        ? t("formSection.errors.invalidEmail")
        : "",
      firstName: !formState.firstName.trim() ? "_" : "",
      phone: !formState.phone.trim() ? "_" : "",
      form: [phone.trim(), email.trim(), firstName.trim()].some((e) => !e)
        ? t("formSection.errors.allFieldsRequired")
        : ""
    });
    if (
      formState.email.trim() &&
      formState.firstName.trim() &&
      formState.phone.trim() &&
      isValidEmail(formState.email)
    ) {
      sendData();
    }
  };

  return (
    <>
      <Wrapper>
        <div>
          <Content>
            <div id="bold">{t("formSection.content.title")}</div>
            <p>{t("formSection.content.text")}</p>
          </Content>
          <FormSection>
            <FormTitle>{t("formSection.form.title")}</FormTitle>
            <div>
              <label id="bold">
                {t("formSection.form.firstName")}
                <Input
                  disabled={loading}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={formState.firstName}
                  error={!!errors.firstName}
                  onChange={handleChange}
                  placeholder={t("formSection.form.firstName")}
                  type="text"
                  name="firstName"
                />
              </label>
              <label id="bold">
                {t("formSection.form.email")}
                <Input
                  disabled={loading}
                  onFocus={handleFocus}
                  value={formState.email}
                  error={!!errors.email}
                  onChange={handleChange}
                  placeholder={t("formSection.form.email")}
                  type="email"
                  name="email"
                />
                {errors.email && <span>{errors.email}</span>}
              </label>
              <label id="bold">
                {t("formSection.form.phone")}
                <Input
                  disabled={loading}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={formState.phone}
                  error={!!errors.phone}
                  onChange={handleChange}
                  placeholder={t("formSection.form.phone")}
                  type="tel"
                  maxLength={15}
                  name="phone"
                />
              </label>
              <span>{errors.form}</span>
              <StyledButton onClick={submit} disabled={loading} p="16px">
                {loading ? (
                  <SmallLoader height={18} borderWidth={2} color="white" />
                ) : (
                  t("formSection.button")
                )}
              </StyledButton>
            </div>
          </FormSection>
        </div>
      </Wrapper>
      {
        <Modal isShow={!!showModal} handleClose={() => setShowModal(0)}>
          <DialogWrapper>
            <TitleH2
              style={{
                textAlign: "left"
              }}
            >
              {t(`contact.email.title`)}
            </TitleH2>
            <TextPlain
              style={{
                whiteSpace: "pre-line",
                wordBreak: "break-word",
                textAlign: "left"
              }}
            >
              {t(`contact.email.text`)}
            </TextPlain>
            <div className="buttons">
              <span />
              <Button main onClick={() => setShowModal(0)}>
                {t(`contact.closeBox`)}
              </Button>
            </div>
          </DialogWrapper>
        </Modal>
      }
    </>
  );
};
